import { ApiSuccess } from "ui/Scripts/source/models/common/apiSuccess";
import { SaveSuccess } from "ui/Scripts/source/models/common/saveSuccess";
import { postApiCall } from "./tokenService";

export const saveReport = (obj: any): Promise<SaveSuccess> => {
    return postApiCall("api/report/save", SaveSuccess, JSON.stringify(obj));
};

export const removeReport = (obj: any): Promise<ApiSuccess> => {
    return postApiCall("api/report/remove", ApiSuccess, JSON.stringify(obj));
};